export class SaleOfferPreparation {
  constructor(
    public hash?: string,
    public preparationDate?: number,
    public observations?: string
  ) { }

  clone() {
    return new SaleOfferPreparation(
      this.hash,
      this.preparationDate,
      this.observations
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-preparation.ts